import React, {Component} from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { commonStyles } from '../../styles/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from 'react-select';

import {MDBSelect} from 'mdbreact'
import { loginReset, registrationRequest } from '../../redux/reducers/login';
import { showDisabilties } from '../../redux/reducers/view';

class renderText extends Component {

  state = {
    disabled: false,

  };

  componentWillMount(){
    var opt =[]
    console.log('Pop',this.props.options)
      try {
        this.props.options.forEach((item) => {
          
          if(this.props.input.value[0] && this.props.input.value==item.iID){
            
            opt.push({'text': item.Name, 'value': String(item.iID), 'checked':true});
          }else{
            if(item.text){
              opt.push({'text': item.text, 'value': String(item.value),'checked':false});
            }else{
              opt.push({'text': item.Name, 'value': String(item.iID),'checked':false});
            }
    
          }
         
        })
      } catch (error) {
        
      
      }
     
    this.setState({
      options: opt
     })
    }
  onChange = (event) => {
    console.log('event change',this.props.input)
   if (this.props.input.onChange && event.length != 0) {
    
    this.props.input.onChange(event);
   } else {
    console.log('event change2',event)
    this.props.input.onChange(null);
   }
   if(this.props.input.name=='disability' && event[0] == '9'){
    this.props.showDisabilties(true)
   }
  
  }
 
  render() {
   
   const { classes, meta, registrationForm, input, label, options, linkedData, form } = this.props;
   const conditionError = meta.error && meta.touched;
   if ((input.name === 'conClientBranchID' || input.name === 'conClientRegionID')
      && form.registration.values.conClientID) {
    this.props.options.forEach((item) => {
      if (item.conClientID === form.registration.values.conClientID) {
        linkedData.push({'Name': item.Name, 'iID': item.iID});
      }
    });
  }
 // const dataToShow2 = linkedData.length > 0 ? linkedData : data;
  
  
   return (
    <FormControl
      
      aria-describedby="name-error-text"
      error={conditionError}
      style={{width:"100%", borderRadius:'0px',fontFamily: 'Roboto', fontSize:'14px', color: '#000', minHeight:'42px', paddingTop:25, zIndex:this.props.depth}}
    >
      
      <MDBSelect
        search
        {...input}
          name={label}
          label={label}
          value={this.props.input.value || ''}
          options={this.state.options}
          selected={this.props.input.value || ''}
          getValue={this.onChange}
          style={{zIndex:10000}}
        />
      {/* <Select 
    {...input}
    name={label}
    options={opt}
    value={this.props.input.value || ''}
    onBlur={() => this.props.input.onBlur(this.props.input.value)}
    onChange={this.onChange.bind(this)}
    theme={theme => ({
      ...theme,
      borderRadius: 0,
      borderColor: '#9E9E9E',
      color: '#000',
      fontSize: '14px',
      fontFamily: 'Roboto-Bold',
      minHeight:'42px'
    })}
   /> */}
      {conditionError && (
        <FormHelperText id="name-error-text" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
   );
  }
 }


const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer
});
const mapDispatchToProps = dispatch => ({
  showDisabilties: (bool) => dispatch(showDisabilties(bool)),
  loginReset: () => dispatch(loginReset()),
});
 export default compose(connect(mapStateToProps, mapDispatchToProps))(renderText)

const styles = () => ({
  ...commonStyles,
});


